import { useEffect, useState } from "react";
import MixModePagesRowSelector from "./MixModePagesRowSelector";

interface IProps {
  totalPages: number;
  onQuantityChanged: (
    blackQuantity: number,
    colourQuantity: number,
    blackPageRange: string,
    colourPageRange: string,
  ) => void;
}

function MixModePagesSelector({ totalPages, onQuantityChanged }: IProps) {
  useEffect(() => {
    setPageSelectorRows([
      {
        startPage: 1,
        endPage: totalPages,
        colourMode: "colour",
      },
    ]);
  }, [totalPages]);

  const [pageSelectorRows, setPageSelectorRows] = useState<
    { startPage: number; endPage: number; colourMode: string }[]
  >([]);

  function handleRowChanged(
    startPage: number,
    endPage: number,
    colourMode: string,
  ): void {
    setPageSelectorRows((prev) => {
      const newResult = [] as {
        startPage: number;
        endPage: number;
        colourMode: string;
      }[];
      let lastEndPage = 0;
      let lastColour = "colour";

      prev.forEach((p) => {
        if (p.startPage === startPage) {
          newResult.push({ startPage, endPage, colourMode });
          if (endPage > lastEndPage) {
            lastEndPage = endPage;
          }
        } else if (p.startPage !== lastEndPage + 1) {
          newResult.push({ ...p, startPage: lastEndPage + 1 });

          if (p.endPage > lastEndPage) {
            lastEndPage = p.endPage;
          }
        } else {
          newResult.push(p);

          if (p.endPage > lastEndPage) {
            lastEndPage = p.endPage;
          }
        }
        lastColour = p.colourMode;
      });

      if (lastEndPage < totalPages) {
        newResult.push({
          startPage: lastEndPage + 1,
          endPage: totalPages,
          colourMode: lastColour === "black" ? "colour" : "black",
        });
      }
      newResult.sort((a, b) => a.startPage - b.startPage);

      const blackQuantity = newResult.reduce(
        (acc, curr) =>
          acc +
          (curr.colourMode === "black" ? curr.endPage - curr.startPage + 1 : 0),
        0,
      );
      const colourQuantity = newResult.reduce(
        (acc, curr) =>
          acc +
          (curr.colourMode === "colour"
            ? curr.endPage - curr.startPage + 1
            : 0),
        0,
      );
      const blackPageRange = newResult
        .filter((r) => r.colourMode === "black")
        .map((r) => `${r.startPage}-${r.endPage}`)
        .join(", ");
      const colourPageRange = newResult
        .filter((r) => r.colourMode === "colour")
        .map((r) => `${r.startPage}-${r.endPage}`)
        .join(", ");
      onQuantityChanged(
        blackQuantity,
        colourQuantity,
        blackPageRange,
        colourPageRange,
      );
      return newResult;
    });
  }

  function getTotalPages(index: number) {
    return index < pageSelectorRows.length - 1
      ? pageSelectorRows[index + 1].endPage - 1
      : totalPages;
  }

  return (
    <>
      <tr>
        <th className="label">
          <label htmlFor="cq-pod-paper-size">
            Mixed Printing Configuration (From Page, To Page, Colour Mode)
          </label>
          <span
            className="woo-selected-variation-item-name"
            data-default=""
          ></span>
        </th>
        <td></td>
      </tr>
      {pageSelectorRows.map((r, i) => (
        <MixModePagesRowSelector
          key={r.startPage}
          startPage={r.startPage}
          endPage={r.endPage}
          colourMode={r.colourMode}
          totalPages={getTotalPages(i)}
          onRowChanged={handleRowChanged}
        />
      ))}
    </>
  );
}

export default MixModePagesSelector;
